/**
 * Generato automaticamente.
 * framework-cmp-domande
 */

export type GetFrontRichiesteStatoDelega =
  (typeof GetFrontRichiesteStatoDelega)[keyof typeof GetFrontRichiesteStatoDelega];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetFrontRichiesteStatoDelega = {
  DELEGATE: 'DELEGATE',
  PROPRIE: 'PROPRIE',
  TUTTE: 'TUTTE',
} as const;
